<template>
	<div>
		<div class="logoTop">
			<el-row>
				<el-col :span="2">
					<div class="grid-content bg-purple">&nbsp;</div>
				</el-col>
				<el-col :span="10">
					<img src="../../assets/images/home/logo.png" alt="logo" class="logo" @click="goHome()" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="search" class="input-with-select">
						<el-button slot="append" @click="getSearch()">搜索</el-button>
					</el-input>
				</el-col>
				<el-col :span="4">
					<div class="concant">
						<p class="phoneText">
							<i class="iconfont el-iconstel-line phone"></i>联系电话
						</p>
						<p class="phone">0371-86623267</p>
					</div>
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
			</el-row>
		</div>
		<div class="menu">
			<el-row>
				<el-col :span="2">
					<div class="grid-content bg-purple">&nbsp;</div>
				</el-col>

				<el-col :span="20">
					<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
						<el-menu-item :key="index" v-for="(item,index ) in menuList" :index="index"
							@click="handleSelect(item.path,index)">
							<span slot="title">{{item.name}}</span>
						</el-menu-item>
						<!-- <el-submenu :index="item.path" v-for="(item,index) in menuList" :key="item.id" v-if="item.children">
							<el-menu-item v-for="(items,index ) in item.children" v-if="!items.children" :index="items.path" :key="index">
								{{items.name}}
							</el-menu-item>
							<template slot="title" v-if="item.children">
								<span>{{item.name}}</span>
							</template>
            </el-submenu>-->
					</el-menu>
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import request from "../../assets/js/request.js";
	import qs from "qs";
	export default {
		data() {
			return {
				activeIndex: '/',
				menuList: [{
						name: "首页",
						path: "/",
						id: 0,
					},
					{
						name: "产品中心",
						path: "/product",
						id: 1,
					},
					{
						name: "案例展示",
						path: "/case",
						id: 2,
					},
					{
						name: "新闻资讯",
						path: "/news",
						id: 3,
					},
					{
						name: "关于广源",
						path: "/about",
						id: 4,
					},
					{
						name: "联系我们",
						path: "/contact",
						id: 5,
					},
				],
				//搜索
				search: "",
			};
		},
		created() {
			if (this.$route.query.path == undefined) {
				this.activeIndex = 0;
			} else {
				this.activeIndex = this.$route.query.path;
			}
			this.getMenu();
		},
		methods: {
			handleSelect(path, index) {
				if (path == '/main') {
					const {
						href
					} = this.$router.resolve({
						path: '/',
					});
					window.open(href, "_blank");
				} else {
					const {
						href
					} = this.$router.resolve({
						path: path,
						query: {
							path: index,
						},
					});
					window.open(href, "_blank");
				}

			},
			goHome() {
				this.activeIndex = "/";
				this.$router.push({
					path: "/",
				});
			},
			getSearch() {
				this.$router.push({
					path: "/product",
					query: {
						keyWord: this.search,
					},
				});
				this.search = "";
			},
			getMenu() {
				request
					.post(
						this.settings.apiBaseUrl + "/api/index/category",
						qs.stringify({}), {
							headers: {},
						}
					)
					.then((res) => {
						if (res.code == 1) {
							this.menuList = res.data;
						} else {
							this.$message.error(res.msg);
						}
					});
			},
		},
	};
</script>

<style scoped="scoped">
	/******************* 顶部start ******************************/
	.logoTop {
		width: 100%;
		height: 109px;
		border-bottom: #ededed;
	}

	.logoTop .el-row {
		width: 100%;
		height: 100%;
	}

	.logoTop /deep/ .el-col-10 {
		height: 100%;
		vertical-align: middle;
		line-height: 109px;
	}

	.logoTop /deep/ .el-col-6 {
		height: 100%;
		vertical-align: middle;
		line-height: 109px;
		text-align: right;
	}

	.logoTop /deep/ .el-col-4 {
		height: 100%;
		vertical-align: middle;
		line-height: 109px;
		text-align: left;
		padding-left: 60px;
	}

	.logoTop .logo {
		width: 66%;
		height: auto;
		vertical-align: middle;
		cursor: pointer;
	}

	/deep/ .el-input-group {
		width: 70% !important;
	}

	/deep/ .el-input__inner {
		border: 1px solid #216bd1;
		border-radius: 0;
	}

	.logoTop /deep/ .el-col-6 /deep/ .el-button {
		background-color: #216bd1;
		border-radius: 0;
		border: 1px solid #216bd1;
		color: #ffffff;
	}

	.logoTop /deep/ .el-col-4 .phoneText {
		height: 20px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #343434;
		line-height: 30px;
	}

	.logoTop /deep/ .el-col-4 .phone {
		height: 20px;
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #595959;
		line-height: 30px;
		margin-top: 10px;
	}

	.concant {
		width: 100%;
		height: 60px;
		vertical-align: middle;
		position: relative;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
	}

	/***************************** 顶部end *********************************/
	/********************************** //菜单start **********************************/
	.menu {
		width: 100%;
		height: 100px;
		background: #216bd1;
		/* background: #FFFFFF; */
		box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
	}

	.menu /deep/ .el-row,
	/deep/ .el-col-20,
	/deep/ .el-menu.el-menu--horizontal {
		height: 100%;
	}

	.menu /deep/ .el-menu.el-menu--horizontal {
		border-bottom: none;
	}

	.menu /deep/ .el-menu--horizontal>.el-menu-item {
		width: 16.666%;
		text-align: center;
		height: 100%;
		line-height: 100px;
		border-bottom: none;
		background: #216bd1;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #ffffff;
	}

	.menu .el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: none;
		background-color: #ffffff;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #216bd1;
	}

	/********************************** //菜单end **********************************/
</style>



// WEBPACK FOOTER //
// src/components/home/menu.vue